import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
//import { Skills } from "./components/Skills";
import { Vorstandschaft } from "./components/Vorstandschaft";
import { Projects } from "./components/Projects";
import { Contact } from "./components/contact";
import { Footer } from "./components/footer";

function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Vorstandschaft />
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;